module.exports = __webpack_public_path__ + "static/media/96.1479d330.png";